import { Button, Input } from "@mui/material";
import { useForm } from "react-hook-form";
import { HOST_URL } from "../common";
import { Modal } from "react-bootstrap";
import styled from "styled-components";
import { useEffect, useState } from "react";
const UpdateInfo = ({
  updateUser,
  setSwitchState,
  showUpdateModal,
  setShowUpdateModal,
}) => {
  const { register, handleSubmit, reset } = useForm({
    defaultValue: {
      department: "",
      mailTo: "",
    },
  });
  const [checked, setChecked] = useState();
  useEffect(
    () => setChecked(updateUser.mailTo === "None" && "0"),
    [updateUser.mailTo]
  );
  // const [checked, setChecked] = useState(false);
  // console.log(updateUser);
  const updateInfo = (newData) => {
    const url = HOST_URL + ":3002/updateInfo";
    const postBody = {
      oldId: updateUser.id,
      name: newData.name,
      id: newData.id,
      pw: newData.pw,
      department: newData.department,
      position: newData.position,
      level: newData.level,
      mailTo: newData.mailTo,
    };
    fetch(url, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(postBody),
      credentials: "include",
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.code === "ok") {
          window.alert("회원 정보 수정을 완료했습니다.");
          reset();
          setSwitchState((current) => !current);
        } else if (result.code === "error") {
          window.alert(result.reason);
        }
      });
    setShowUpdateModal(false);
  };

  const modalClose = () => {
    setShowUpdateModal(false);
    reset();
  };
  return (
    <>
      <Modal size="md" show={showUpdateModal} onHide={modalClose}>
        <Modal.Header closeButton>
          <Modal.Title>회원 수정 </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RegisterDiv>
            <form
              id="registerForm"
              onSubmit={handleSubmit((data) => updateInfo(data))}
            >
              <div style={{ display: "relative" }}>
                <div style={{ marginBottom: "7px" }}>
                  <label
                    style={{ width: "70px", textAlign: "center" }}
                    htmlFor="name"
                  >
                    이름
                  </label>
                  <Input
                    defaultValue={updateUser.name}
                    style={{
                      backgroundColor: "white",
                      paddingLeft: "7px",
                      width: "75%",
                    }}
                    id="name"
                    placeholder="이름"
                    {...register("name", { required: true })}
                  />
                </div>
                <div style={{ marginBottom: "7px" }}>
                  <label
                    style={{ width: "70px", textAlign: "center" }}
                    htmlFor="id"
                  >
                    ID
                  </label>
                  <Input
                    defaultValue={updateUser.id}
                    style={{
                      backgroundColor: "white",
                      paddingLeft: "7px",
                      width: "75%",
                    }}
                    id="id"
                    placeholder="ID"
                    {...register("id", { required: true })}
                  />
                </div>
                <div style={{ marginBottom: "7px" }}>
                  <label
                    style={{ width: "70px", textAlign: "center" }}
                    htmlFor="pw"
                  >
                    PW
                  </label>
                  <Input
                    defaultValue={updateUser.pw}
                    style={{
                      backgroundColor: "white",
                      paddingLeft: "7px",
                      width: "75%",
                    }}
                    id="pw"
                    placeholder="Password"
                    type="password"
                    {...register("pw", { required: true })}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "7px",
                  }}
                >
                  <div style={{ width: "70px", textAlign: "center" }}>
                    <span>부서</span>
                  </div>
                  <div>
                    <div style={{ display: "flex" }}></div>
                    <select
                      defaultValue={updateUser.department}
                      {...register("department", { required: true })}
                    >
                      <option value="">부서를 선택해주세요</option>
                      <option value="임원실">임원실</option>
                      <option value="최고기술경영자">최고기술경영자</option>
                      <option value="경영기획">경영기획</option>
                      <option value="한국공간정보연구소">
                        한국공간정보연구소
                      </option>
                      <option value="콘텐츠사업부">콘텐츠사업부</option>
                      <option value="전략기획">전략기획</option>
                      <option value="마케팅사업부">마케팅사업부</option>
                    </select>
                  </div>
                </div>
                <div style={{ marginBottom: "7px" }}>
                  <label
                    style={{ width: "70px", textAlign: "center" }}
                    htmlFor="position"
                  >
                    직급
                  </label>
                  <Input
                    defaultValue={updateUser.position}
                    style={{
                      backgroundColor: "white",
                      paddingLeft: "7px",
                      width: "75%",
                    }}
                    id="position"
                    placeholder="직급"
                    {...register("position", { required: true })}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "7px",
                  }}
                >
                  <div style={{ width: "70px", textAlign: "center" }}>
                    <span>권한</span>
                  </div>
                  <div>
                    <div style={{ display: "flex" }}>
                      <input
                        id="level0"
                        type="radio"
                        value="0"
                        defaultChecked={updateUser.level === "0"}
                        onClick={(e) => setChecked(e.target.value)}
                        // onClick={() => setChecked(true)}
                        {...register("level", { required: true })}
                      />
                      <label htmlFor="level0" style={{ marginLeft: "10px" }}>
                        최고관리자
                      </label>
                    </div>
                    <div style={{ display: "flex" }}>
                      <input
                        id="level1"
                        type="radio"
                        value="1"
                        defaultChecked={updateUser.level === "1"}
                        onClick={(e) => setChecked(e.target.value)}
                        // onClick={() => setChecked(false)}
                        {...register("level", { required: true })}
                      />
                      <label htmlFor="level1" style={{ marginLeft: "10px" }}>
                        관리자
                      </label>
                    </div>
                    <div style={{ display: "flex" }}>
                      <input
                        id="level2"
                        type="radio"
                        value="2"
                        defaultChecked={updateUser.level === "2"}
                        onClick={(e) => setChecked(e.target.value)}
                        // onClick={() => setChecked(false)}
                        {...register("level", { required: true })}
                      />
                      <label htmlFor="level2" style={{ marginLeft: "10px" }}>
                        멤버
                      </label>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "47px",
                  }}
                >
                  <div
                    style={{
                      width: "70px",
                      textAlign: "center",
                      fontSize: "12px",
                    }}
                  >
                    <span>최종보고자</span>
                  </div>
                  <div>
                    <div style={{ display: "flex" }}>
                      <select
                        defaultValue={updateUser.mailTo}
                        {...register("mailTo", { required: true })}
                        disabled={checked === "0"}
                      >
                        <option value="None">최종보고자 없음</option>
                        <option value="한동훈">한동훈 전무</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    marginTop: "10px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Button
                    onClick={() => reset()}
                    style={{
                      marginLeft: "20px",
                      backgroundColor: "white",
                      borderRadius: "4px",
                      border: "1px solid black",
                    }}
                  >
                    변경 초기화
                  </Button>
                  <Button
                    variant="contained"
                    type="submit"
                    style={{ marginRight: "30px" }}
                  >
                    확인
                  </Button>
                </div>
              </div>
            </form>
          </RegisterDiv>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default UpdateInfo;
const RegisterDiv = styled.div`
  @media screen and (max-width: 500px) {
    font-size: 15px;
  }
`;
